module.exports = __webpack_public_path__ + "img/5.c8a2ee38.svg";